module.exports = __webpack_public_path__ + "static/media/icon_site_grey.59755a22.svg";